import { dispatch } from "../store/store";
import { logErrorWithPayload } from "../services/logService";
import {
  setIsMemberLoading,
  setMembersData,
  setRolesData,
  setServicesData,
  getMemberData,
  getMemberDataV2,
  getServicesData,
  addMemberData,
  updateMemberData,
  updateMemberDataV2,
  getMemberByIdData,
  setCurrentMemberData,
  getOrbitAgencyServicesByCompanyIdData,
  deleteUserByIdData,
  generateCertificateData,
  addPinCodeData,
  addDigitalSignatureData,
  deleteDigitalSignatureData,
  updateCurrentMemberProfileData,
  updateUserWeekAvailabilityData,
  getUsersProfileData,
  addUserAccreditationData,
  deleteUserAccreditationData,
  viewUserAccreditationData,
  deleteDigitalCertificateData,
   getPendingInvitesData,
  deleteInviteData,
  getDefaultCompanyServiceUrlData,
} from "../features/memberSlice/memberSlice";

const reducerName = "member";

// #region State Setters

export const setMembers = (memberData) => {
  dispatch(setMembersData(memberData));
};
export const setRoles = (roleData) => {
  dispatch(setRolesData(roleData));
};
export const setServices = (servicesData) => {
  dispatch(setServicesData(servicesData));
};
export const setMemberLoading = (isLoading) => {
  dispatch(setIsMemberLoading(isLoading));
};
export const setCurrentMember = (memberObject) => {
  dispatch(setCurrentMemberData(memberObject));
};
// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers
export const getmembers = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(getMemberData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = [];
  }
  return result;
};

export const getmembersV2 = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(getMemberDataV2(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = [];
  }
  return result;
};

export const getServices = async () => {
  let result = [];
  try {
    result = await dispatch(getServicesData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }
  return result;
};

export const getMemberById = async (memberId) => {
  let result = null;

  try {
    result = await dispatch(getMemberByIdData(memberId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, memberId);
    result = null;
  }

  return result;
};

export const addMember = async (data) => {
  let result = null;

  try {
    result = await dispatch(addMemberData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};

export const updateMember = async (data) => {
  let result = null;

  try {
    result = await dispatch(updateMemberData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};

export const updateMemberV2 = async (data) => {
  let result = null;

  try {
    result = await dispatch(updateMemberDataV2(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};

export const getOrbitAgencyServicesByCompanyId = async (companyID) => {
  let result = null;
  try {
    result = await dispatch(
      getOrbitAgencyServicesByCompanyIdData(companyID),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyID);
    result = null;
  }
  return result;
};

export const deleteUserById = async (email) => {
  let result = null;

  try {
    result = await dispatch(deleteUserByIdData(email)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }

  return result;
};

export const generateCertificate = async (data) => {
  let result = null;
  try {
    result = await dispatch(generateCertificateData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const addPinCode = async (data) => {
  let result = null;
  try {
    result = await dispatch(addPinCodeData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const addDigitalSignature = async (data) => {
  let result = null;
  try {
    result = await dispatch(addDigitalSignatureData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const deleteDigitalSignature = async (userEmail) => {
  let result = null;
  try {
    result = await dispatch(deleteDigitalSignatureData(userEmail)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
export const updateCurrentMemberProfile = async (userEmail) => {
  let result = null;
  try {
    result = await dispatch(updateCurrentMemberProfileData(userEmail)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
export const updateUserWeekAvailability = async (data) => {
  let result = null;
  try {
    result = await dispatch(updateUserWeekAvailabilityData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getUsersProfile = async () => {
  let result = null;

  try {
    result = await dispatch(getUsersProfileData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }

  return result;
};

export const addUserAccreditation = async (data) => {
  let result = null;
  try {
    result = await dispatch(addUserAccreditationData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const deleteUserAccreditation = async (accreditationID) => {
  let result = null;
  try {
    result = await dispatch(
      deleteUserAccreditationData(accreditationID),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const viewUserAccreditation = async (accreditationID) => {
  let result = null;
  try {
    result = await dispatch(
      viewUserAccreditationData(accreditationID),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const deleteDigitalCertificate = async (userEmail) => {
  let result = null;
  try {
    result = await dispatch(deleteDigitalCertificateData(userEmail)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getDefaultCompanyServices = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(
      getDefaultCompanyServiceUrlData(companyId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = [];
  }
  return result;
};
// #endregion
export const getPendingInvites = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(getPendingInvitesData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);
    result = [];
  }
  return result;
};


export const deleteInvite = async (inviteId) => {
  let result = null;
  try {
    result = await dispatch(deleteInviteData(inviteId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, inviteId);
    result = null;
  }
  return result;
};
